import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function initNews() {


	if(document.querySelector('.featured-posts')) {
		const sliderFeatured = document.querySelector('.featured-posts .swiper');

		const swiperFeatured = new Swiper(sliderFeatured, {
			modules: [Navigation, Autoplay, Pagination],
	    slidesPerView: 1,
	    simulateTouch: false,
	    speed: 600,
	    loop: true,
	    autoplay: {
	      delay: 8000,
	      disableOnInteraction: false,
	    },
	    // pagination
		  pagination: {
		    el: document.querySelector('.featured-posts .swiper-pagination'),
		    type: 'bullets',
		  },
		  // Navigation arrows
		  navigation: {
		    nextEl: document.querySelector('.featured-posts .swiper-button-next'),
		    prevEl: document.querySelector('.featured-posts .swiper-button-prev'),
		  },
	  });


	  if(document.querySelectorAll('.featured-posts .featured-posts__item').length == 1) {
	  	document.querySelector('.featured-posts .swiper-pagination').style.display = 'none';
	  	document.querySelector('.featured-posts .nav').style.display = 'none';
	  }
	}



	// categories :
	if(document.querySelector('.categories')) {
		let selected = '';

		if(document.querySelector('.categories a.active')) {
			selected = document.querySelector('.categories a.active');

			document.querySelector('.categories .selected .text').innerText = selected.innerText;
		} else {
			document.querySelector('.categories .selected .text').innerText = 'All';
		}

		document.querySelector('.categories').addEventListener('click', () => {
			document.querySelector('.categories').classList.toggle('open');
		});

		const specifiedElement = document.querySelector('.categories');

		// I'm using "click" but it works with any event
		document.addEventListener('click', event => {
		  const isClickInside = specifiedElement.contains(event.target)

		  if (!isClickInside) {
		    document.querySelector('.categories').classList.remove('open');
		  }
		})
	}


}